/* eslint-disable jsx-a11y/media-has-caption */

import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import { Card } from "@mui/material";
import XaneDemoVideo from "assets/video/XaneDemo.mp4";
import { useState } from "react";

export default function Youtube() {
  const [open, setOpen] = useState(false);
  const handleToggle = () => setOpen((prevState) => !prevState);

  const handleVideoEnd = () => {
    setOpen(false);
  };

  return (
    <Card
      sx={{
        display: "flex",
        height: {
          xs: "15.125rem",
          sm: "35.1875rem",
          md: "35.1875rem",
          lg: "35.1875rem",
        },
        width: "100%",
        position: "relative",
        borderRadius: "1.875rem",
        backgroundColor: "#000",
        cursor: "pointer",
        overflow: "hidden",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClick={handleToggle}
    >
      {open ? (
        <video
          width="100%"
          height="100%"
          controls
          autoPlay
          onEnded={handleVideoEnd}
          style={{
            objectFit: "fill",
            display: "block",
          }}
        >
          <source src={XaneDemoVideo} type="video/mp4" />
        </video>
      ) : (
        <div
          style={{
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <PlayCircleIcon
            sx={{
              color: "white",
              fontSize: "4rem",
              opacity: 0.8,
            }}
          />
        </div>
      )}
    </Card>
  );
}
